import React from "react";
import PropTypes from "prop-types";
import { IoBuild, IoAlertCircle, IoCheckmarkCircle } from "react-icons/io5";
import styled from "styled-components";

const BcInvoiceSummaryRow = ({ line, isFlagged }) => {
  if (isFlagged) {
    return (
      <InvoiceRowContainerStyled>
        <li>{line?.body?.description}</li>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <h5 style={{ color: "#fe703f", marginRight: "1rem" }}>
            Variant Code update required in Business Central
          </h5>
          <IoBuild
            size={20}
            style={{ color: "#fe703f", marginRight: "1rem" }}
          />
        </div>
      </InvoiceRowContainerStyled>
    );
  }

  return line?.body?.error ? (
    <InvoiceRowContainerStyled>
      <span>
        <p style={{ color: "red" }}>Invoice Line Error:</p>
        <p>{line?.body?.error?.message}</p>
      </span>
      <IoAlertCircle
        size={20}
        style={{ color: "#fe703f", marginRight: "1rem" }}
      />
      <IoCheckmarkCircle
        size={20}
        style={{ color: "#35d687", marginRight: "1rem" }}
      />
    </InvoiceRowContainerStyled>
  ) : (
    <InvoiceRowContainerStyled>
      <li>{line?.body?.description}</li>
      <IoCheckmarkCircle
        size={20}
        style={{ color: "#35d687", marginRight: "1rem" }}
      />
    </InvoiceRowContainerStyled>
  );
};

const InvoiceRowContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
`;

BcInvoiceSummaryRow.propTypes = {
  line: PropTypes.object,
  isFlagged: PropTypes.bool
};

export default BcInvoiceSummaryRow;
